import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Paper,
  Typography,
  TablePagination,
} from "@material-ui/core";
import TierIcon from "./TierIcon";
//import { FixedSizeList } from "react-window";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import reportTranslator from "../../../../../../utils/reportTranslator";
import { useTranslate } from "react-admin";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    //marginTop: theme.spacing(1),
    overflowX: "hidden",

    //Add
    height: "100%",
  },
  container: {
    maxHeight: window.innerHeight - 280,
    color: "#828282",
    boxShadow: "0px 5px 5px #ebebeb",
  },
  footerCell: {
    fontSize: 20,
    fontWeight: "bolder",
    left: 0,
    bottom: 52, // <-- KEY
    zIndex: 2,
    position: "sticky",
    backgroundColor: "white",
  },
  pagination: {
    left: 0,
    bottom: 0, // <-- KEY
    zIndex: 2,
    position: "sticky",
    backgroundColor: "white",
  },
  footerFullScreenCell: {
    fontSize: 20,
    fontWeight: "bolder",

    backgroundColor: "white",
  },
  ColorText: {
    color: "#828282",
    minWidth: 120,
  },
  TextTableBody: {
    textAlign: "left",
  },
  TableHeader: { boxShadow: "0px 5px 5px #ebebeb" },
  tableHeadCell: {
    paddingTop: 9,
    paddingBottom: 9,
  },
  textHeader: {
    fontSize: 14,
  },
  textData: {
    fontSize: 14,
  },
  tableDataCell: {
    minHeight: 68,
    maxHeight: 68,
    boxSizing: "border-box",
    paddingTop: 0,
    paddingBottom: 0,
  },
}));
const StyledTableRow = withStyles((i) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: i.palette.action.hover,
    },
    height: 68,
    minHeight: 68,
  },
}))(TableRow);

const AccessibleTable = React.forwardRef((props, ref) => {
  const [footer, setFooter] = useState([]);
  const classes = useStyles();
  const translate = useTranslate();
  const { allRows, rowPerPage, page, setPage } = props;
  if (!props.data || props.data.list.length === 0) {
    return (
      <>
        <Typography
          style={{
            margin: "50px auto",
            position: "relative",
            top: 0,
            bottom: 0,
          }}
          variant="h4"
          align="center"
        >
          No data
        </Typography>
      </>
    );
  }

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container} component={Paper}>
        <Table ref={ref} stickyHeader aria-label="sticky table">
          <TableHead className={classes.TableHeader}>
            {Object.entries(props.data.list[0]).map(([key, _], index) => {
              return (
                <TableCell
                  className={[classes.ColorText, classes.tableHeadCell]}
                  ref={(cell) => {
                    if (cell !== null && footer.length <= index)
                      setFooter((headers) => [...headers, cell.offsetWidth]);
                  }}
                  key={index}
                  align="left"
                >
                  <Typography className={classes.textHeader} noWrap>
                    {translate(reportTranslator(key))}
                  </Typography>
                </TableCell>
              );
            })}
          </TableHead>

          <TableBody>
            {props.data.list.map((row, index) => {
              return (
                <StyledTableRow key={index}>
                  {Object.entries(row).map(([key, val], index2) => {
                    //    console.log("Val is " + val);

                    if (val === "") {
                      val = "-";
                    } else if (typeof val === "string") {
                      //          console.log("string");
                    } else if (typeof val === "number") {
                      if (isNaN(val)) val = 0;
                    } else {
                      val = "-";
                    }
                    return (
                      <React.Fragment key={index2}>
                        {key === "Tier" ? (
                          <TableCell
                            className={[
                              classes.ColorText,
                              classes.tableDataCell,
                            ]}
                          >
                            <TierIcon level={val} />
                          </TableCell>
                        ) : (
                          <TableCell
                            //dangerouslySetInnerHTML={{ __html: val }}
                            align="left"
                            className={[
                              classes.ColorText,
                              classes.tableDataCell,
                            ]}
                          >
                            {isNaN(val) ? (
                              !Array.isArray(val) ? (
                                String(val)
                                  ?.split("\n")
                                  .map((line, index) => (
                                    <Typography
                                      key={index}
                                      className={classes.textHeader}
                                      style={{ wordWrap: "break-word" }}
                                    >
                                      {line}
                                    </Typography>
                                  ))
                              ) : (
                                <Typography
                                  className={classes.textHeader}
                                  style={{ wordWrap: "break-word" }}
                                >
                                  {val.join(", ")}
                                </Typography>
                              )
                            ) : (
                              <Typography className={classes.textHeader}>
                                {Number(val).toLocaleString()}{" "}
                              </Typography>
                            )}
                          </TableCell>
                        )}
                      </React.Fragment>
                    );
                  })}
                </StyledTableRow>
              );
            })}
          </TableBody>
          <TableFooter>
            {Object.entries(props.data.summarytier[0]).map(
              ([_, val], index) => (
                <TableCell key={index} className={classes.footerCell}>
                  {isNaN(val) || val === ""
                    ? val
                    : Number(val).toLocaleString()}
                </TableCell>
              )
            )}
          </TableFooter>
        </Table>
        <TablePagination
          component="div"
          className={classes.pagination}
          count={allRows}
          rowsPerPage={rowPerPage}
          page={page}
          onChangePage={(_, pageNum) => {
            setPage(pageNum);
          }}
          rowsPerPageOptions={rowPerPage}
        />
      </TableContainer>
    </Paper>
  );
});

export default AccessibleTable;
